<template>
    <div class="bank-pay">
        <header class="header" >
            <h3>对公支付</h3>
            <i class="close eqf-no" @click="close" />
        </header>
        <div class="bank">
            <h2 class="bank-title"><a @click="copy">复制转账信息</a>转账信息：</h2>
            <table id="copy-content">
            <tr>
                <th>收款人户名</th><th>北京中网易企秀科技有限公司</th>
            </tr>
            <tr>
                <th>账号</th><th>110926895210116</th>
            </tr>
            <tr>
                <th>银行账户</th><th>招商银行股份有限公司北京亚运村支行</th>
            </tr>
            <tr>
                <th>行名行号</th><th>308100005060</th>
            </tr>
            <tr>
                <th>付款金额</th><th><span class="red">6200</span>元</th>
            </tr>
            </table>
            <h2 class="bank-title">
                注意事项：
            </h2>
            <p class="items">1. 请务必保证转账金额准确，多转、少转和分次转账，都会影响订单对账；</p>
            <p class="items">2. 对账完成后，2个小时内会员权益发放至当前账号；</p>
            <p class="items">3. 转账完成后，微信扫描下方二维码通知客服。</p>
            <div class="qrcode">
                <img src="@/assets/images/kefu-qrcode.png" width="100" height="100" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    close: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {}
    }
  },
  methods: {
    copy () {
      let content = document.getElementById('copy-content')
      let selection = window.getSelection()
      let range = document.createRange()
      if (selection.rangeCount > 0) selection.removeAllRanges()
      range.selectNode(content)
      selection.addRange(range)
      document.execCommand('copy')
      this.$message('复制成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-pay {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  height: 520px;
  transform: translate(-50%, -50%);
  transition: all 0.3s;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    padding: 28px;
    margin-bottom: 10px;

    h3 {
        font-size: 18px;
    }

    .close {
        font-size: 24px;
        cursor: pointer;
        color: #666666;

        &:hover {
            color: #333333;
        }
    }
}

.bank{
    width: 100%;
    padding: 0 28px 28px;
    text-align: left;
    .bank-title{
        font-size: 14px;
        color: #333;
        padding-bottom: 12px;
        a{
            float: right;
            font-weight: 400;
            font-size: 14px;
            color: #1261FF;
            cursor: pointer;
            &:hover{
                text-decoration: underline;
            }
        }
    }
    table{
        margin-bottom: 16px;
        border: 1px solid #e6ebed;
        border-radius: 4px;
        width: 100%;
        font-size: 14px;
        border-collapse: separate;
        border-bottom: none;
    .red {
        color: #FF5448;
        margin-right: 4px;
    }
    th{
        font-weight: 400;
    }
    td,th{
        border-bottom: 1px solid #e6ebed;
        height: 32px;
        line-height: 32px;
    }
    th:first-child{
        background-color: #f5f5f5;
        width: 154px;
        border-right: 1px solid #e6ebed;
        text-align: center;
    }
    th:last-child{
        padding-left: 10px;
    }
    }
    .items{
        color: #666;
        font-size: 12px;
        line-height: 18px;
    }

    .qrcode {
        margin-top: 20px;
        text-align: center;
    }
}
</style>
